import { t } from 'i18next';
import { LocalVideoTrack } from 'livekit-client';
import { virtualBackgroundService as service } from 'features/VirtualBackground/classes/VirtualBackgroundService';
import { selectActiveProcessorInfo } from 'features/VirtualBackground/state/selectors/virtualBackground';
import { BLUR_RADIUS, LIGHT_BLUR_RADIUS } from '../constants';
import { virtualBackgroundStore } from '../state/store/virtualBackground';
import { PROCESSOR_TYPES } from '../types';

export const setupVirtualBackgrounds = () => {
    const processors = new Map();
    processors.set('none', { type: PROCESSOR_TYPES.none, text: t('web_button_no') });
    processors.set('lightBlur', {
        type: PROCESSOR_TYPES.blur,
        blurRadius: LIGHT_BLUR_RADIUS,
        text: t('videoconference_light_blur'),
    });
    processors.set('blur', {
        type: PROCESSOR_TYPES.blur,
        blurRadius: BLUR_RADIUS,
        text: t('videoconference_blur'),
    });
    virtualBackgroundStore.appendAvailableProcessors(processors);
};

// Новые функции для работы с сервисом
export const useRoomVirtualBackground = () => {
    // const service = useVirtualBackgroundService();

    const setupRoomBackground = async (localVideoTrack: LocalVideoTrack | null) => {
        await service.applyToTrack('room', localVideoTrack);
        await service.removeManager('prejoin');
    };

    const prepareRoomBackground = async () => {
        // Менеджер создаётся всегда — updateAllManagers должен его найти,
        // если пользователь выберет фон уже находясь в комнате
        const manager = service.getOrCreateManager('room');

        // Тяжёлый процессор (MediaPipe/WebGL) создаём только если фон реально выбран
        const processorInfo = selectActiveProcessorInfo();
        if (processorInfo && processorInfo.type !== PROCESSOR_TYPES.none) {
            await manager.createProcessor();
        }
    };

    const cleanupOnLeave = async () => {
        await service.removeManager('room');
    };

    const getRoomProcessor = () => {
        return service.getProcessor('room');
    };

    return {
        setupRoomBackground,
        prepareRoomBackground,
        cleanupOnLeave,
        getRoomProcessor,
    };
};
